module.exports = __webpack_public_path__ + "img/logo2.5b53b24f.png";